export const roomActionTypes = {
    SET_NEW_ROOM: 'SET_NEW_ROOM',
    SET_ROOM_INFO: 'SET_ROOM_INFO'
};